var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9151_64)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 87.5,
    r: 87.5,
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5768 44.1043C78.9981 43.2343 66.6368 47.838 57.7193 56.7555C48.8381 65.6368 44.2343 77.9981 45.1043 90.5768C46.6631 113.233 66.2743 130.996 89.7281 130.996H113.871C124.528 130.996 131.996 122.296 131.996 109.789V88.6918C131.996 65.2743 114.233 45.663 91.5768 44.1043ZM124.746 109.789C124.746 118.127 120.359 123.746 113.871 123.746H89.7281C70.0806 123.746 53.6593 108.956 52.3543 90.1056C51.6293 79.5931 55.4718 69.298 62.8668 61.8668C69.6818 55.0518 78.9256 51.2455 88.5681 51.2455C89.4018 51.2455 90.2718 51.2455 91.1056 51.318C109.992 52.623 124.746 69.0443 124.746 88.6918V109.789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9151_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6ca0ccae8dfff6f4bfb7b3cc001d5446.svg";
export { ForwardRef as ReactComponent };